export default async function setSiteLogo( logo ) {

	const data = new FormData();
    data.append( "action", "astra_sites_set_site_data" );
	data.append( "param", "site-logo" );
	data.append( "logo", logo.id );
	data.append( "logo-width", logo.width );
	data.append( 'security', starterTemplates.nonce );

	fetch( ajaxurl, {
		method: 'post',
		body: data
	});
}
